import upperFirst from "./upperFirst";

/**
 * @param {string} prefix
 * @param {string} value
 */
export default function prefixPropName(prefix, value) {
    return prefix + upperFirst(value);
}



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/lib/utils/prefixPropName.js
// module id = 120
// module chunks = 2